export default __webpack_public_path__ + "static/media/1.98868aef.webp";